import { useEffect, useState } from 'react';
import { Link } from 'react-router';
import { api } from '../api';
import { formatDateOnly } from '../dates';
type Contact = { name: string; startsOn: string; endsOn: string | null };
export type BuildingOwner = {
  buildingId: string;
  appointed?: boolean;
  isActing?: boolean;
  ownershipStatus: string;
  primary: Contact | null;
  acting: (Contact & { decision: string; availability: string })[];
  manageHref?: string;
};
export function OwnershipContact({ owner }: { owner?: BuildingOwner | undefined }) {
  if (!owner) return <span>Ownership unavailable</span>;
  return (
    <>
      <span>{owner.primary?.name ?? owner.ownershipStatus}</span>
      {owner.primary && <small>{owner.ownershipStatus}</small>}
      {owner.acting.map((a, i) => (
        <small key={i}>
          Acting: {a.name} · {a.decision === 'building_relationship' ? 'Building relationship' : 'Cross-engine coordination'} · {a.availability}
        </small>
      ))}
      {owner.manageHref && (
        <small>
          <Link to={owner.manageHref}>Manage ownership</Link>
        </small>
      )}
    </>
  );
}
export function BuildingOwnership({ building,compact=false }: { building: string;compact?:boolean }) {
  const [owner, setOwner] = useState<BuildingOwner>(),
    [unavailable, setUnavailable] = useState(false);
  useEffect(() => {
    const c = new AbortController();
    setOwner(undefined);
    setUnavailable(false);
    void api<BuildingOwner>('/api/buildings/' + building + '/operating-contact', { signal: c.signal })
      .then((o) => {
        if (!c.signal.aborted) setOwner(o);
      })
      .catch(() => {
        if (!c.signal.aborted) setUnavailable(true);
      });
    return () => c.abort();
  }, [building]);
  if(compact)return <section className="building-manager-fact" aria-label="Property Manager"><h2>Manager</h2>
    <p>{unavailable?'Ownership unavailable':!owner?'Loading responsibility…':owner.primary?.name??owner.ownershipStatus}</p>
    <details><summary>Responsibility details</summary>{owner&&<OwnershipContact owner={owner}/>} {owner?.primary&&<p>Appointed from {formatDateOnly(owner.primary.startsOn)}{owner.primary.endsOn?' until '+formatDateOnly(owner.primary.endsOn)+' (exclusive)':''}</p>}<Link
 to={'/portfolio?building='+building}>Building oversight</Link><Link to={'/buildings/'+building+'/outcomes?building='+building}>Building outcomes</Link></details>
  </section>;
  return (
    <section className="pm-ownership-summary" aria-label="Property Manager">
      <h2>Property Manager</h2>
      <p>{unavailable ? 'Ownership unavailable' : !owner ? 'Loading responsibility…' : <OwnershipContact owner={owner} />}</p>
      {owner?.primary && (
        <p>
          Appointed from {formatDateOnly(owner.primary.startsOn)}
          {owner.primary.endsOn ? ' until ' + formatDateOnly(owner.primary.endsOn) + ' (exclusive)' : ''}
        </p>
      )}
      <Link to={'/portfolio?building=' + building}>Building oversight</Link>
      <Link to={'/buildings/' + building + '/outcomes?building=' + building}>Building outcomes</Link>
    </section>
  );
}
